import { ApiService } from "@/services/api/ApiService";

import type { ConversationDigest, NeedsAttention, WeeklySummary } from "@/types/activity";

const getWeeklySummary = async (): Promise<WeeklySummary> => {
  return ApiService.invoke<WeeklySummary>({
    resource: "activities",
    action: "weekly-summary",
  });
};

const getNeedsAttention = async (): Promise<NeedsAttention> => {
  return ApiService.invoke<NeedsAttention>({
    resource: "activities",
    action: "needs-attention",
  });
};

const getConversationDigest = async (params: {
  agentId?: string | null;
  dateRange: string;
}): Promise<ConversationDigest> => {
  return ApiService.invoke<ConversationDigest>({
    resource: "activities",
    action: "conversation-digest",
    data: {
      agentId: params.agentId ?? undefined,
      dateRange: params.dateRange,
    },
  });
};

export const InsightsService = {
  getWeeklySummary,
  getNeedsAttention,
  getConversationDigest,
};
